import React from 'react';
import { Box, Typography } from '@mui/material';
import { School as SchoolIcon, Apps as AppsIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { useUniversityConfig } from '../../../contexts/UniversityConfigProvider';

interface LogoProps {
  width?: number;
  showText?: boolean;
  variant?: 'header' | 'sidebar' | 'mobile' | 'collapsed';
  sx?: any;
}

const Logo: React.FC<LogoProps> = ({ width = 180, showText = true, variant = 'header', sx = {} }) => {
  const theme = useTheme();
  const { config } = useUniversityConfig();

  console.log('config',config);
  
  const getWidth = () => {
    switch (variant) {
      case 'mobile':
        return 160;
      case 'sidebar':
        return 200;
      case 'collapsed':
        return 40;
      default:
        return width;
    }
  };

  const isCollapsed = variant === 'collapsed';

  return (
 
    <Box
      component={Link}
      to="#"
      sx={{
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        color: theme.palette.primary.main,
        height: 0, 
        ...sx
      }}
    >
      {config?.theme?.logo && !isCollapsed ? (
        <Box
          component="img"
          src={config.theme.logo}
          alt={`${config.name} Logo`}
          sx={{
            width: getWidth(),
             height: '62px!important',
            objectFit: 'contain',
            ...(theme.palette.mode === 'dark' && {
              backgroundColor: 'white',
              width: '200px',
             
              borderRadius: '4px'
            })
          }}
        />
      ) : (
        <>
          {isCollapsed ? (
            config?.theme?.shortLogo ? (
              <Box
                component="img"
                src={config.theme.shortLogo}
                alt={`${config.name} Logo`}
                sx={{
                  width: 40,
                  objectFit: 'contain',
                  ...(theme.palette.mode === 'dark' && {
                    backgroundColor: 'white',
                    padding: '2px',
                    borderRadius: '2px'
                  })
                }}
              />
            ) : (
              <AppsIcon sx={{ fontSize: 28 }} />
            )
          ) : (
            <SchoolIcon sx={{ mr: showText ? 1 : 0 }} />
          )}
          {showText && !isCollapsed && (
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              University LMS
            </Typography>
          )}
        </>
      )}
    </Box>
  );
};

export default Logo;
